document.addEventListener('DOMContentLoaded', function() {
    const hamburgerBtn = document.querySelectorAll('.hamburger-btn');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    const closeBtn = document.querySelector('.mobile-menu-close');
    const backdrop = document.querySelector('.mobile-menu-backdrop');
    const chatbotLink = mobileMenuOverlay.querySelector('.js-chatbot-display-button');

    const closeOverlay = () => {
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    const openOverlay = () => {
        mobileMenuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }


    hamburgerBtn?.forEach(btn => {
        btn.addEventListener('click', openOverlay);
    });

    closeBtn?.addEventListener('click', closeOverlay);

    backdrop?.addEventListener('click', function(e) {
        if (e.target === backdrop) {
            closeOverlay();
        }
    });

    mobileMenuOverlay?.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
            closeOverlay()
        }
    });

    // Add this inside the DOMContentLoaded event listener
    chatbotLink?.addEventListener('click', closeOverlay);
});